// extracted by mini-css-extract-plugin
module.exports = {"grid":"EmptyList_grid__13yVy","icon":"EmptyList_icon__hDXav","head":"EmptyList_head__30v2G","subhead":"EmptyList_subhead__2qeJt"};